export default class OrderManager
{
    constructor(params)
    {
        this.params = params;
        this.options = {};
    }

    fetchOptions()
    {
        return new Promise((resolve, reject) => {
            try {
                BX.ajax.runAction("lpost:delivery.api.OrderEditDelivery.getOptions", {
                    data: {
                        orderId: this.getOrderId()
                    }
                }).then(res => resolve(res.data))
            }
            catch (error) {
                reject(error);
            }
        })
    }

    setOptions(options)
    {
        this.options = options;
        return this;
    }

    init()
    {
        return false;
    }

    getOptions()
    {
        return this.options;
    }

    isProfileLpost()
    {

        if(!this.options.profiles) {
            return false;
        }

        for (let profile of this.options.profiles) {
            if(profile.ID == this.getDeliveryProfileId()) {
                return true;
            }
        }

        return false;
    }

    getOrderId()
    {
        if(!BX.Sale) {
            throw new Error("BX.Sale not found");
        }

        let formOrderData = BX.Sale.Admin.OrderEditPage.getAllFormData();

        if(formOrderData['order_id']) {
            return formOrderData['order_id'];
        }

        return this.params.order_id ?? 0;
    }

    getDeliveryId()
    {
        let formOrderData = BX.Sale.Admin.OrderEditPage.getAllFormData();

        for (let shipmentId in formOrderData['SHIPMENT']) {
            let shipmentData = formOrderData['SHIPMENT'][shipmentId];
            return shipmentData['DELIVERY_ID'];
        }

        return false;
    }

    getDeliveryProfileId()
    {
        let formOrderData = BX.Sale.Admin.OrderEditPage.getAllFormData();

        for (let shipmentId in formOrderData['SHIPMENT']) {
            let shipmentData = formOrderData['SHIPMENT'][shipmentId];
            return shipmentData['PROFILE'];
        }

        return false;
    }

    getDeliveryPrice()
    {
        let formOrderData = BX.Sale.Admin.OrderEditPage.getAllFormData();

        for (let shipmentId in formOrderData['SHIPMENT']) {
            let shipmentData = formOrderData['SHIPMENT'][shipmentId];
            return shipmentData['BASE_PRICE_DELIVERY'];
        }

        return false;
    }

    getSelectedDeliveryProfile()
    {
        if(!this.options.profiles) {
            return false;
        }

        for (let profile of this.options.profiles) {
            if(profile.ID == this.getDeliveryProfileId()) {
                return profile;
            }
        }
    }

    getLocationId()
    {
        return this.options.locationId;
    }

    renderAddress(value)
    {
        BX.Sale.Admin
            .OrderBuyer
            .propertyCollection
            .getAddress()
            .setValue(value);
    }

    renderPrice()
    {
        return false;
    }

    blockProperty(props = [])
    {
        if(!Array.isArray(props) || props.length === 0) return false

        for(let prop of props) {
            let el = document.querySelector(`[name='PROPERTIES[${prop['ID']}]']`);
            if(!el) continue;
            el.setAttribute("disabled", true);
        }

    }

    renderDateDelivery(dateDelivery)
    {
        //
    }

    renderTimeDelivery(timeDelivery)
    {
        // ..
    }

    setPropById(id, value)
    {
        try {
            BX.Sale.Admin
                .OrderBuyer
                .propertyCollection
                .getById(id)
                .setValue(value);
        }
        catch (error) {
            console.log(error);
        }
    }

    refresh()
    {
        return false;
    }

    displayInputAddressContainer()
    {
        return false;
    }

    getPersonTypeId()
    {
        return false;
    }
    
    isOrderAjaxComponent(field = null){
        return true;
    }





}